export const USER_TOKEN = 'USER_TOKEN';

export const REFRESH_TOKEN = 'REFRESH_TOKEN';

export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export const PATHS = {
    LOGIN: '/login',
    NOTFOUND: '/404',
    DASHBOARD: '/dashboard',
    BLANK: '',
    CATEGORIES: '/categories',
    OFFERS: '/offers',
    VOUCHER: '/offers/voucher/',
    CARD: '/card',
    USER: '/user',
    ORGANIZE: '/organize',
    POSITION: '/position',
    COLLECT_KV: '/collect-kv'
};
